module.exports = __webpack_public_path__ + "img/18.eb948da3.jpg";